module.exports = __webpack_public_path__ + "static/media/footerlogo.e1e62a94.svg";